import React from 'react';

export const EmotionPredictionTable = ({ predictions, showFirstCount, fontSize, maxHeight }) => {
    const limitedPredictions = showFirstCount ? predictions.slice(0, showFirstCount) : predictions;
    const extraStyle = fontSize ? { fontSize: `${fontSize}rem` } : {};

    if (!predictions || predictions.length === 0) {
        return <div style={extraStyle}>Emotion Predictions Will Be Displayed Here</div>;
    }

    return (
        <div 
            style={{ maxHeight: maxHeight || '55vh', overflowY: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none'}}
            className="hide-scrollbar"
        >
            <table className="table table-hover prediction-table table-sm" style={extraStyle}>
                <thead>
                    <tr>
                        <th scope="col">Emotion</th>
                        <th scope="col">Prediction</th>
                    </tr>
                </thead>
                <tbody>
                    {limitedPredictions.map((emotion, index) => (
                        <tr key={index}>
                            <td>{emotion.emotion}</td>
                            <td style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <span style={{minWidth:"4rem"}}>{emotion.percentage}%</span>
                                <div className="progress" style={{ flex: 1 }}>
                                    <div
                                        className={"progress-bar " + emotion.emotion.toLowerCase()}
                                        role="progressbar"
                                        style={{ width: `${emotion.percentage}%` }}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};


export const EmotionPredictionList = ({ predictions, showFirstCount, fontSize, maxHeight }) => {
    const limitedPredictions = showFirstCount ? predictions.slice(0, showFirstCount) : predictions;
    const extraStyle = fontSize ? { fontSize: `${fontSize}rem` } : {};

    if (!predictions || predictions.length === 0) {
        return <div style={extraStyle}>Emotion Predictions Will Be Displayed Here</div>;
    }

    return (
        <div 
            style={{ 
                maxHeight: maxHeight || '55vh', 
                overflowY: 'auto', 
                scrollbarWidth: 'none', 
                msOverflowStyle: 'none'
            }}
            className="hide-scrollbar"
        >
            <div className="prediction-list" style={{ ...extraStyle, width: '100%' }}>
                {limitedPredictions.map((emotion, index) => (
                    <div key={index} className="prediction-list-item" style={{ display: 'flex', alignItems: 'center', margin: '8px 0' }}>
                        <div style={{ flexGrow: 1 }}>{emotion.emotion}</div>
                        <div style={{ flexGrow: 2, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span>{emotion.percentage}%</span>
                            <div className="progress" style={{ height: '1.1rem', width: '100%' }}>
                                <div
                                    className={"progress-bar " + emotion.emotion.toLowerCase()}
                                    role="progressbar"
                                    aria-valuemin="0" 
                                    aria-valuemax="100"
                                    style={{ width: `${emotion.percentage}%`, backgroundColor: emotion.color }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
